import { inject, NgZone } from '@angular/core';
import { SelectOption } from '@examdojo/util/select-option';
import { firstValueFrom } from 'rxjs';
import { SmartLinkConfig } from './smart-link-config.model';

export function toReactSmartLinkConfig(
  config: SmartLinkConfig,
): Omit<SmartLinkConfig, 'selectOptions'> & { getOptions?: () => Promise<Array<SelectOption<string>>> } {
  const ngZone = inject(NgZone);
  return {
    resolve: (identifier, context) => {
      ngZone.run(() => config.resolve(identifier, context));
    },
    getOptions: config.selectOptions ? () => ngZone.run(() => firstValueFrom(config.selectOptions!())) : undefined,
  };
}
